import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';

import partnerPropTypes from '../../../partnerPropTypes.js';
import Page from '../../../page.jsx';

const PaymentExpiredDetails = ({ partner }) => (
    <Page heading="Betalingsfristen har gått ut">
        <p>
            {partner.name} betalte ikke innen tidsfristen og avtalen gjelder
            ikke lenger. {partner.name} må starte Trygg betaling på nytt om du
            fortsatt vil selge til {partner.name}.
        </p>

        <div className="r-phl r-ptl">
            <Link to="/samtale" className="button fullwidth">
                OK
            </Link>
        </div>
    </Page>
);

PaymentExpiredDetails.propTypes = {
    partner: partnerPropTypes.isRequired,
};

function mapStateToProps(state) {
    return {
        partner: state.partner,
    };
}

export default connect(mapStateToProps)(PaymentExpiredDetails);



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/statusDetails/paymentExpiredDetails.jsx